// Drag and drop item types
export const ItemTypes = {
  MEDIA_ITEM: 'media_item',
  TIMELINE_CLIP: 'timeline_clip',
  LAYER: 'layer',
};

// Layer types
export const LayerTypes = {
  VIDEO: 'video',
  AUDIO: 'audio',
  TEXT: 'text',
  IMAGE: 'image',
};

// File type helpers
export const isVideoFile = (file) => {
  return file.type.startsWith('video/');
};

export const isAudioFile = (file) => {
  return file.type.startsWith('audio/');
};

export const isImageFile = (file) => {
  return file.type.startsWith('image/');
};

export const getFileType = (file) => {
  if (isVideoFile(file)) return LayerTypes.VIDEO;
  if (isAudioFile(file)) return LayerTypes.AUDIO;
  if (isImageFile(file)) return LayerTypes.IMAGE;
  return null;
};

// Time formatting
export const formatTime = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  const ms = Math.floor((seconds % 1) * 100);
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}.${ms.toString().padStart(2, '0')}`;
};

// Generate unique ID
export const generateId = () => {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}-${Math.random().toString(36).substr(2, 9)}`;
};
